export const otpSettingRoutes = [
  {
    path: 'setting/otp',
    name: 'otp_start',
    component: () => import('@/views/dashboard/otp/OtpSettingStart.vue'),
    props: true,
    meta: {
      PageTitle: 'dashboard_title.setting_2fa',
    },
  },
  {
    path: 'setting/otp-set-complete',
    name: 'otp_complete',
    component: () => import('@/views/dashboard/otp/OtpSettingComplete.vue'),
    props: true,
    meta: {
      PageTitle: 'dashboard_title.setting_2fa',
    },
  },
  {
    path: 'setting/otp_unset',
    name: 'otp_unset',
    component: () => import('@/views/dashboard/otp/DisableOtp.vue'),
    props: true,
    meta: {
      PageTitle: 'dashboard_title.unsetting_2fa',
    },
  },
  {
    path: 'setting/recovery_code',
    name: 'recovery_code',
    component: () => import('@/views/dashboard/otp/RecoveryCodeCheck.vue'),
    props: true,
    meta: {
      PageTitle: 'dashboard_title.check_recoverycode',
    },
  },
  {
    path: 'setting/otp_setting',
    name: 'otp_setting',
    component: () => import('@/views/dashboard/otp/Setting.vue'),
    children: [
      {
        path: 'app_install',
        name: 'otp_app_install',
        component: () => import('@/views/dashboard/otp/AppInstall.vue'),
        meta: {
          PageTitle: 'dashboard_title.regist_otp',
        },
      },
      {
        path: 'verify_qr',
        name: 'otp_verify_qr',
        component: () => import('@/views/dashboard/otp/VerifyQR.vue'),
        meta: {
          PageTitle: 'dashboard_title.regist_otp',
        },
      },
      {
        path: 'verify_code',
        name: 'otp_verify_code',
        component: () => import('@/views/dashboard/otp/VerifyCode.vue'),
        meta: {
          PageTitle: 'dashboard_title.regist_otp',
        },
      },
    ],
    props: true,
  },
]

export const settingRoutes = [
  {
    path: 'setting',
    name: 'setting',
    component: () => import('@/views/dashboard/setting/SettingMain.vue'),
    redirect: '/dashboard/setting/profile',
    children: [
      {
        path: 'profile',
        name: 'profile_setting',
        component: () => import('@/views/dashboard/setting/ProfileSetting.vue'),
        meta: {
          PageTitle: 'setting.title',
        },
      },
      {
        path: 'service',
        name: 'service_setting',
        component: () => import('@/views/dashboard/setting/ServiceSetting.vue'),
        meta: {
          PageTitle: 'setting.title',
        },
      },
      {
        path: 'security',
        name: 'security_setting',
        component: () =>
          import('@/views/dashboard/setting/SecuritySetting.vue'),
        meta: {
          PageTitle: 'setting.title',
        },
      },
      // {
      //   path: 'history',
      //   name: 'history',
      //   component: () => import('@/views/dashboard/setting/History.vue'),
      //   meta: {
      //     PageTitle: 'setting.title',
      //   },
      // },
    ],
  },
]
